export const PROTOCOL_MAIL_STATUS_HEADER = 'X-Protocol-Mail-Status';

// The backend sends "sent" or "failed". A response without the header comes from a
// backend that does not report the protocol mail, so it is not treated as a failure.
export const isProtocolMailSent = (res: Response) =>
  res.headers.get(PROTOCOL_MAIL_STATUS_HEADER) !== 'failed';
